import DTO from './DTO';

class PresetDayDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'days.all',
        type: Boolean,
        labelKey: 'days.all',
      },
      {
        name: 'days.even',
        type: Boolean,
        labelKey: 'days.even',
      },
      {
        name: 'days.odd',
        type: Boolean,
        labelKey: 'days.odd',
      },
      {
        name: 'days.working',
        type: Boolean,
        labelKey: 'days.working',
      },
      {
        name: 'days.holidays',
        type: Boolean,
        labelKey: 'days.holidays',
      },
      {
        name: 'days.saturday',
        type: Boolean,
        labelKey: 'days.saturday',
      },
      {
        name: 'days.sunday',
        type: Boolean,
        labelKey: 'days.sunday',
      },
    ];
    super(attributes, params, isValidInit);
  }

  getData() {
    return {};
  }
}

export default PresetDayDTO;
